// Directorio de clientes: personas que hicieron check-in o tienen datos de facturación.
export const clientesDir = {
  title: "Clientes",
  subtitle: "Todas las personas que han hecho check-in o tienen datos de facturación. Se guardan solas y nunca se duplican.",
  searchLabel: "Buscar cliente",
  searchPlaceholder: "Nombre, documento, email o teléfono",
  filters: {
    todos: "Todos",
    checkin: "Con check-in",
    fiscal: "Con datos fiscales",
    reservas: "Con reservas",
  },
  cols: {
    client: "Cliente",
    document: "Documento",
    phone: "Teléfono",
    stays: "Estancias",
    lastStay: "Última estancia",
  },
  checkins: "{n} check-in | {n} check-ins",
  bookings: "{n} reserva | {n} reservas",
  fiscalBadge: "Fiscal",
  noDocument: "Sin documento",
  noName: "Sin nombre",
  emptyTitle: "Aún no hay clientes",
  emptyText: "Cada persona que complete un check-in aparecerá aquí automáticamente.",
  emptySearch: "No hay clientes que coincidan con «{q}».",
  loadError: "No se pudieron cargar los clientes.",
  pageOf: "{from}–{to} de {total}",
  prev: "Anterior",
  next: "Siguiente",
  docTypes: {
    P: "Pasaporte",
    ID: "DNI",
    IM: "NIE",
    I: "Documento de identidad",
    D: "DNI",
    N: "NIE",
    X: "Permiso de residencia",
    CC: "Cédula",
    CE: "Cédula de extranjería",
    TI: "Tarjeta de identidad",
    PPT: "PPT",
    PEP: "PEP",
  },
  sheet: {
    close: "Cerrar",
    createBooking: "Crear reserva",
    personal: "Datos personales",
    document: "Documento",
    address: "Dirección",
    fiscal: "Datos fiscales",
    noFiscal: "Sin datos fiscales. Se añaden al facturar o desde Facturación → Clientes fiscales.",
    defaultProfile: "Predeterminado",
    bookings: "Reservas",
    noBookings: "Sin reservas vinculadas.",
    companions: "Ha viajado con",
    noCompanions: "No ha coincidido con nadie más en sus reservas.",
    timesTogether: "{n} vez | {n} veces",
    invoices: "Facturas",
    noInvoices: "Sin facturas.",
    viewPdf: "Ver PDF",
    email: "Email",
    phone: "Teléfono",
    birthDate: "Fecha de nacimiento",
    sex: "Sexo",
    nationality: "Nacionalidad",
    docType: "Tipo",
    docNumber: "Número",
    expiry: "Caducidad",
    support: "Nº de soporte",
    street: "Dirección",
    zip: "Código postal",
    city: "Ciudad",
    country: "País de residencia",
    roleCheckin: "Check-in",
    roleHolder: "Titular",
    loadError: "No se pudo abrir la ficha del cliente.",
  },
  sexes: {
    M: "Hombre",
    F: "Mujer",
  },
  // Reutilizar al crear (reserva y check-in manual)
  picker: {
    missingPolice: "De este cliente no hay datos de policía guardados en esta cuenta. Complétalos ahora y quedarán para la próxima vez.",
    searchSaved: "Buscar cliente guardado",
    searchPlaceholder: "Nombre, documento o teléfono…",
    noResults: "Ningún cliente guardado coincide.",
    selected: "Datos rellenados desde Clientes",
    clear: "Quitar",
  },
  match: {
    title: "Ya existe este cliente",
    text: "{name} ya está guardado en Clientes. Puedes rellenar todos sus datos con un toque.",
    use: "Usar sus datos",
    dismiss: "No es esta persona",
    applied: "Datos de {name} rellenados. Revisa las fechas de la estancia y firma.",
    companionsTitle: "Viajó antes con",
    companionsHint: "Toca una persona para registrarla con sus datos.",
    registerCompanion: "Registrar a {name}",
  },
};
